import { combineReducers } from "redux";

import invoices from "./invoices";
import clients from "./clients";
import auth from "./auth";
import profiles from "./profiles";
import product from "./product";
import assistants from "./assistants";
import xl from "./xl";
import bank from "./bank";
import checks from "./checks";
import billingCycle from "./billingCycle";
import accountReceivables from "./accountReceivables";

export default combineReducers({
  invoices,
  clients,
  auth,
  profiles,
  product,
  assistants,
  xl,
  bank,
  checks,
  billingCycle,
  accountReceivables,
});
